module.exports = __webpack_public_path__ + "static/img/product3newmobile.464f984c.png";